import DOMPurify from 'dompurify';


class formatters {

	static sanitize(inputHtml) {
		if (!inputHtml || typeof inputHtml !== 'string') {
			return inputHtml;
		}

		return DOMPurify.sanitize(inputHtml, {
			FORBID_TAGS: ['script'], // Remove script tags only
			FORBID_ATTR: [], // No forbidden attrs here, because we handle event handlers below dynamically
			// Use hook to remove all attributes starting with "on"
			ADD_ATTR: [], // keep default allowed attributes

			// Hook to remove all on* attributes dynamically
			BEFORE_SANITIZE_ATTRIBUTES: (node) => {
				[...node.attributes].forEach(attr => {
					if (attr.name.toLowerCase().startsWith('on')) {
						node.removeAttribute(attr.name);
					}
					// Remove javascript: URLs
					if (
						(attr.name.toLowerCase() === 'href' || attr.name.toLowerCase() === 'src') &&
						attr.value.trim().toLowerCase().startsWith('javascript:')
					) {
						node.removeAttribute(attr.name);
					}
				});
			},
		});
	}
}

export default {
	install(Vue) {
		Object.defineProperties(Vue.prototype, {
			$formatters: {
				get() {
					return formatters;
				},
			},
		});
	},
};
